import * as React from "react";
import {useEffect, useState} from "react";
import {fieldLabelClasses} from "../../../../../components/general/fieldStyles.ts";
import {cn} from "../../../../../lib/utils.ts";
import {SecondaryButton} from "../../../../../components/general/SecondaryButton.tsx";
import {PrimaryButton} from "../../../../../components/general/PrimaryButton.tsx";
import {FilterPendingBadge} from "../../../../../components/general/FilterPendingBadge.tsx";
import {useFilterStore} from "../../../../../contexts/FilterStore.tsx";
import { DateRangeInput } from "../../../../../components/general/DateRangeInput/DateRangeInput.tsx";
import type { DateRangeValue } from "../../../../../components/general/DateRangeInput";
import { parseDate, formatDateForInput } from "../../../../../components/general/DateRangeInput/utils/dateRangeUtils.ts";
import {BusinessCardSort} from "./BusinessCardSort.tsx";
import {BusinessCardFilter, CashFlowDirection} from "./BusinessCardFilter.tsx";
import {SortOptionsEnum} from "./types.ts";

export interface UnmatchedTransactionsFilterBarProps {
    selectedSort: SortOptionsEnum;
    onSortChange: (sortOption: SortOptionsEnum) => void;
    selectedFilter: CashFlowDirection;
    onFilterChange: (filter: CashFlowDirection) => void;
}

export default function UnmatchedTransactionsFilterBar(props: UnmatchedTransactionsFilterBarProps) {
    const { selectedSort, onSortChange, selectedFilter, onFilterChange } = props;
    const { state, dispatch } = useFilterStore();
    const { dateRange: storeDateRange, customerId } = state.common;

    const [dateRange, setDateRange] = useState<DateRangeValue>({
        from: parseDate(storeDateRange.from),
        to: parseDate(storeDateRange.to),
    });
    const [isDirty, setIsDirty] = useState(false);

    const handleReset = () => {
        dispatch({ type: 'RESET' });
        setIsDirty(false);
    };

    useEffect(() => {
        setDateRange({
            from: parseDate(storeDateRange.from),
            to: parseDate(storeDateRange.to),
        });
        setIsDirty(false);
    }, [storeDateRange.from, storeDateRange.to, customerId]);

    const handleApplyFilters = () => {
        setIsDirty(false);
        dispatch({
            type: 'SET_FILTERS',
            payload: {
                common: {
                    dateRange: {
                        from: formatDateForInput(dateRange.from),
                        to: formatDateForInput(dateRange.to)
                    }
                }
            }
        });
    };

    return (
        <div className="flex mb-4 bg-white w-full items-end justify-between gap-4">
            <div className="flex items-end flex-wrap gap-4">
                <div className="w-[234px]">
                    <label className={cn(fieldLabelClasses, "mb-2")}>
                        Periode
                    </label>
                    <DateRangeInput
                        value={dateRange}
                        onChange={(value) => { setDateRange(value); setIsDirty(true); }}
                    />
                </div>
                {customerId && (
                    <>
                        <div>
                            <label className={cn(fieldLabelClasses, "mb-2")}>
                                Sorteren
                            </label>
                            <BusinessCardSort
                                selectedSort={selectedSort}
                                onSortChange={onSortChange}
                            />
                        </div>
                        <div>
                            <label className={cn(fieldLabelClasses, "mb-2")}>
                                Weergave
                            </label>
                            <BusinessCardFilter
                                selectedFilter={selectedFilter}
                                onFilterChange={onFilterChange}
                            />
                        </div>
                    </>
                )}
            </div>

            <div className="flex items-center gap-3">
                <FilterPendingBadge show={isDirty}/>
                <SecondaryButton title={"Wissen"} onClick={handleReset}/>
                <PrimaryButton title={"Toepassen"} onClick={handleApplyFilters}/>
            </div>
        </div>
    );
}
